import { DialogService, GridAction } from '@eforall/dashboard';
import { Note } from '@interfaces';
import { BaseService } from '../notes.part';

export function getActions(dialog: DialogService, service: BaseService, openNotesDialog: (note?: Note) => Promise<void>) {

	const actions: GridAction<Note>[] = [
		{
			iconClass: 'fa-regular fa-pencil',
			label: 'Edit Note',
			isEnabled: rows => !!rows.length,
			execute: async rows => {
				await openNotesDialog(rows[0]!); //rows[0] is guaranteed to exist because of the isEnabled check
			}
		},
		{
			iconClass: 'fa-regular fa-trash',
			label: 'Delete Note',
			isEnabled: rows => !!rows.length,
			execute: async rows => {
				const yes = await dialog.confirm('Are you sure you want to remove the Note?');
				if (yes) {
					await service.explorer.func.note.deleteNote({ noteId: rows[0]!.noteId });
					await service.reloadData();
				}
			}
		},
	];

	return actions;
}